import { useEffect } from 'react';
import tracking from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import { pageTypeConstants as pageTypes } from '../constants/pageTypeConstants';

export function useSbTileAbTestTracking() {
    useEffect(() => {
        const trackingData = getAbTestTrackingData(document.cookie, 'SB_TILE_CAROUSEL_TEST');
        tracking.trackAbTestEvent(trackingData, pageTypes.BROWSE);
    }, []);
}
